import { RouteConfig } from "vue-router";

const registrosEgresos: RouteConfig = {
  path: "/registrosEgresos",
  name: "registrosEgresos",
  component: () => import(/* webpackChunkName: "registros-egresos" */ "@/views/RegistrosEgresos.vue"),
};

export default registrosEgresos;
